let env = process.env.REACT_APP_ENV;
let baseUrl = '';
let loginPage = 'default';

let lastTenant = undefined;
let tenantCode = localStorage.getItem('tenantCode');
if (tenantCode && tenantCode.trim().length > 0) {
    lastTenant = tenantCode;
}

export let qkUrl = '';
export let eproScaleUrl = '';

//开发环境
if (env === 'development') {
    baseUrl = 'https://edc-saas-test.huimeimt.com/server/'
    // baseUrl = 'http://10.130.8.47:6060'
    // qkUrl = 'http://localhost:3030/';
    qkUrl = 'https://edc-saas-test.huimeimt.com/scale/';
    eproScaleUrl = 'https://edc-saas-test.huimeimt.com/eproScale/';

}
// else if (env === 'test') {
//     baseUrl = 'http://106.14.197.93:6060/'
// }
//测试环境
else if (env === 'test') {
    // qkUrl = 'https://risingstar-test.huimeimt.com/scale/';
    qkUrl = 'https://edc-saas-test.huimeimt.com/scale/';
    baseUrl = 'https://edc-saas-test.huimeimt.com/server/';
    eproScaleUrl = 'https://edc-saas-test.huimeimt.com/eproScale/';
    if (lastTenant && lastTenant === 'TENANT-013') {
        loginPage = 'hd';
    }
}
//生产环境（未定）
else if (env === 'production') {
    qkUrl = 'https://scale-saas.huimeihealth.com.cn/scale/';
    baseUrl = 'https://edc-saas.huimeihealth.com.cn/server/';
    eproScaleUrl = 'https://edc-saas.huimeihealth.com.cn/eproScale/';
    if (lastTenant && lastTenant === 'TENANT-013') {
        loginPage = 'hd';
    }
}

export const BASE_URL = baseUrl;
export const TIMEOUT = 300000;
export const LOGIN_PAGE = loginPage;